import type { IconProps } from './types';

function LaunchIcon(props: IconProps) {
  const { size = 32, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M21 24.1777H11V10.5918L16 5.5918L21 10.5918V24.1777Z" stroke={color} strokeWidth="2" />
      <path d="M16 12.1777V14.1777" stroke={color} strokeWidth="2" />
      <path d="M16 20.1777V28.1777" stroke={color} strokeWidth="2" />
      <path d="M6 18.6756L11 16.1777V23.8751L6 26.373V18.6756Z" stroke={color} strokeWidth="2" />
      <path d="M26 18.6756L21 16.1777V23.8751L26 26.373V18.6756Z" stroke={color} strokeWidth="2" />
    </svg>
  );
}

export { LaunchIcon };
